/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fill_All_FieldsInputs */

const en_fill_all_fields = /** @type {(inputs: Fill_All_FieldsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please fill all fields`)
};

const es_fill_all_fields = /** @type {(inputs: Fill_All_FieldsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completa todos los campos`)
};

/**
* | output |
* | --- |
* | "Please fill all fields" |
*
* @param {Fill_All_FieldsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const fill_all_fields = /** @type {((inputs?: Fill_All_FieldsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fill_All_FieldsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fill_all_fields(inputs)
	return es_fill_all_fields(inputs)
});